import api, { authClient } from './index';
import { toast } from 'react-toastify';

import Cookie from 'universal-cookie';

const cookies = new Cookie();

const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
    authorization: `Bearer ${cookies.get('authToken')}`,
  },
};

export const publishProduct = async formData => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        '/products/publish-product',
        formData,
        config
      );
      resolve(res);
      } catch (error) {
        if (error.response) {
          const { status, data } = error.response;
          if (status === 413) {
            toast.error('File too large: Please upload an image smaller than 2MB.');
          } else if (status === 401) {
            cookies.remove('authToken', { path: '/' });
            cookies.remove('user', { path: '/' });
            cookies.remove('userId', { path: '/' });
            toast.error('Your session has expired. Please login again.');
            window.location.href = '/auth/sign-in';
          } else if (status === 400) {
            toast.error(data.message || 'Bad Request: Invalid request data.');
          } else if (status === 403) {
            toast.error('Forbidden: You do not have permission to access this resource.');
          } else if (status === 404) {
            toast.error('Not Found: The requested product could not be found.');
          } else if (status === 500) {
            toast.error('Server Error: Please try again later.');
          } else {
            toast.error(data.message || 'An error occurred while publishing the product.');
          }
        } else if (error.request) {
          toast.error('Network Error: Please check your internet connection and try again.');
        } else {
          toast.error(error.message);
        }
        reject(error);
      }
  });
};

export const verifyPixel = async formData => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api.post('/vendor/check-pixel', formData, config);
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};
export const getButtons = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api.get('/vendor/getbutton', config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

export const getProductCategory = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api.get('/vendor/get-category', config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
